import { Box, Stack, Typography } from "@mui/material";
import PropTypes from "prop-types";

function EditorForm({ title, action, children }) {
  return (
    <Box
      sx={{
        p: 2,
        flexGrow: 1,
        maxWidth: 1,
      }}
    >
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fill, minmax(min(17rem, 100%), 1fr))",
          gap: 2,
        }}
      >
        <Stack
          direction="row"
          sx={{
            justifyContent: "space-between",
            alignItems: "center",
            gridColumn: "-1 / 1",
          }}
        >
          <Typography variant="h6">{title}</Typography>
          <Box sx={{ flexGrow: 1 }} />
          {action}
        </Stack>
        {children}
      </Box>
    </Box>
  );
}

EditorForm.propTypes = {
  title: PropTypes.string,
  action: PropTypes.node,
  children: PropTypes.node,
};

export default EditorForm;
